import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {FunctionBarSearchModel} from "../function-bar-search.model";
import {FunctionBarEntityModel} from "../function-bar-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-function-bar-search-page",
    templateUrl: "./function-bar-search-page.component.html",
    providers: [provideSearchModel(FunctionBarSearchModel), provideEntityModel(FunctionBarEntityModel)]
})
export class FunctionBarSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
